module.exports = __webpack_public_path__ + "photo-5.47877b1b.png";


//////////////////
// WEBPACK FOOTER
// ./client/images/neighborhood/preview/photo-5.png
// module id = 683
// module chunks = 0